import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import { TailSpin } from  'react-loader-spinner';
import Colors from '../../library/Colors';
import '../logging/logging.css';
import SftGlobalData from '../../library/SftGlobalData';
import AddIcon from '@mui/icons-material/Add';
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import Button from '@mui/material/Button';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import MailIcon from '@mui/icons-material/Mail';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrash, faCheckCircle, faCopy } from '@fortawesome/free-solid-svg-icons';
import Box from '@mui/material/Box';
import { surface } from '../timeclock/tcFormat';
import { ApprovalFilter, DocsSearch, approvalMode } from '../docs/DocsParts';

function LinkCell (props) {
    return (<Link to={"/"+props.lang+"/templates/edit/"+props.id} style={{width: '100%', height: '100%', alignContent: 'center', alignItems: 'center', display: 'flex'}}>{props.children}</Link>)
}

const TemplateScreen = (props) =>  {  
    const [loading, setLoading] = useState(true);
    const [searchValue, setSearchValue] = useState("");
    const [includeApproved, setIncludeApproved] = useState(true);
    const [onlyApproved, setOnlyApproved] = useState(false);

    const [headers, setHeaders] = useState([]);

    const initialGrid = getCookie("initialStateTemplate") === "{}" ? {columns: {columnVisibilityModel: {},}} : JSON.parse(getCookie("initialStateTemplate"));
    const gridColumns = [
        {
            field: 'title',
            headerName: 'Template',
            minWidth: 300,
            headerAlign: 'left',
            align: 'left',
            display: 'flex',        
            renderCell: (params) => {
                return <LinkCell id={params.row.id} lang={params.row.lang} theme={params.row.theme} ><span>{params.row.title}</span></LinkCell>}
        },
        {
            field: 'type',
            headerName: props.t('type'),
            minWidth: 50,
            maxWidth: 75,  
            headerAlign: 'center',
            align: 'center',
            display: 'flex',  
            renderCell: (params) => {
                return params.row.type === "ETICKET" ? <MailIcon style={{color: Colors.sft_blue}}/> : <LibraryBooksIcon style={{color: Colors.sft_blue}}/>
                }
        },
        {
            field: 'edit',
            headerName: props.t('edit'),
            minWidth: 60,    
            maxWidth: 60,  
            align: 'center',      
            headerAlign: 'center',
            display: 'flex',  
            renderCell: (params) => {
            return  ((props.login.sft_group === "ADMIN" || props.login.sft_group === "SUPER") || (!params.row.confirmed /*&& props.login.id === params.row.created_by*/)) ? <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{navigate("/"+props.lang+"/templates/edit/"+params.row.id)}} >
                        <FontAwesomeIcon icon={faPencilAlt} color={Colors.def_orange} size="2x" />
                    </Button> : <div></div>;        
            }
        },
        {
            field: 'copy',
            headerName: props.t('copy'),
            minWidth: 60,    
            maxWidth: 60,  
            align: 'center',      
            headerAlign: 'center', 
            display: 'flex',  
            renderCell: (params) => {
              return  <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{onDuplicateManual(params.row.id)}} ><FontAwesomeIcon icon={faCopy} color={Colors.def_grey} size="2x" /></Button>
              }
        },
        {
            field: 'delete',
            headerName: "",
            minWidth: 60,    
            maxWidth: 60,  
            align: 'center',      
            headerAlign: 'center', 
            display: 'flex',  
            renderCell: (params) => {
              return  (props.login.sft_group === "ADMIN" || props.login.sft_group === "SUPER") ? <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{onDeleteManual(params.row.id)}} >
                          <FontAwesomeIcon icon={faTrash} color={Colors.def_red} size="2x" />
                      </Button> : <div></div>;        
              }
        },
        {
              field: 'confirm',
              headerName: "",
              minWidth: 60,    
              maxWidth: 60,  
              align: 'center',      
              headerAlign: 'center', 
              display: 'flex',  
              renderCell: (params) => {
                return  (params.row.confirmed === 0 && (props.login.sft_group === "ADMIN" || props.login.sft_group === "SUPER")) ? <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{onActivateManual(params.row.id)}} ><FontAwesomeIcon icon={faCheckCircle} color={Colors.def_green} size="2x" /></Button>
                                                   : <div></div>
                }
        },
      ];
    let navigate = useNavigate();
    const apiRef = useGridApiRef();

    useEffect(() => {
        props.changeScreen('logging');
        try{
            let sessionApproved = sessionStorage.getItem('approvedTemplates');
            if(sessionApproved !== null){setIncludeApproved(sessionApproved === 'true');}
        }catch(ex){}

        fetchHeaders();
    }, [props.api]);

    const fetchHeaders = () => {
        SftGlobalData.post('templates&action=fetchHeaders', {
            sft_id: props.login.sft_id,
            sft_group: props.login.sft_group,
            login: props.login.login
        }).then(response => {
            //console.log("error?", typeof response?.error);
            if (typeof response.data?.error === "undefined")
                setHeaders(response.data);
            setLoading(false);
        });
    }

    const onDuplicateManual = (id) => {
        if (window.confirm(props.t('confirm_duplicate_document')) === true) {
            let postData = {
                sft_id: props.login.sft_id,
                sft_group: props.login.sft_group,
                login: props.login.login,
                id: id
            }
            SftGlobalData.post('templates&action=duplicate', postData).then(response => {
                fetchHeaders();
            });
        }
    }

    const onActivateManual = (id) => {
        if (window.confirm(props.t('confirm_activate_document')) === true) {
            let postData = {
                sft_id: props.login.sft_id,
                sft_group: props.login.sft_group,
                login: props.login.login,
                id: id,
                active: true
            }
            SftGlobalData.post('templates&action=activate', postData).then(response => {
                fetchHeaders();
            });
        }
    }

    const onDeleteManual = (id) => {
        if (window.confirm(props.t('confirm_delete_document')) === true) {
            let postData = {
                sft_id: props.login.sft_id,
                sft_group: props.login.sft_group,
                login: props.login.login,
                id: id
            }
            SftGlobalData.post('templates&action=delete', postData).then(response => {
                fetchHeaders();
            });
        }
    }

    useEffect(()=>{
        try{
            apiRef.current.subscribeEvent(
                'columnOrderChange',
                ()=>{visibilityChangedHandler();},
            );
        }catch(ex){
    
        }
    }, [apiRef]);

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "{}";
    }

    const visibilityChangedHandler = () => {
        let temp = apiRef.current.exportState();
        if(typeof temp.columns.columnVisibilityModel === "undefined"){
            temp.columns.columnVisibilityModel = {};
        }
        try{
            temp.preferencePanel.open = false;
        }catch(e){
    
        }
        try{
            delete temp.pagination;
        }catch(e){
            console.error(e);
        }
        setCookie("initialStateTemplate", JSON.stringify(temp), 100000);
    }
    
    
    // Embedded: shown as the Templates tab of the Documents (manuals) page, without its own frame and title.
    const s = surface(props.theme);
    const isAdmin = props.login.sft_group === "ADMIN" || props.login.sft_group === "SUPER";
    const setApproval = (mode) => {
        setOnlyApproved(mode === 'pending');
        const include = mode !== 'approved';
        setIncludeApproved(include);
        sessionStorage.setItem('approvedTemplates', include);
    };
    // Embedded: shown as the Templates tab of the Documents (manuals) page, without its own frame and title.
    const body = (
        <>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 1.5 }}>
            <DocsSearch t={props.t} value={searchValue} onChange={setSearchValue} />
            {isAdmin && <ApprovalFilter t={props.t} mode={approvalMode(includeApproved, onlyApproved)} onChange={setApproval} />}
            {props.login.sft_status != "3" && (
                <Button variant="contained" disableElevation startIcon={<AddIcon />} onClick={() => navigate("/" + props.lang + "/templates/edit/+")}
                    sx={{ textTransform: 'none', height: 40, borderRadius: '8px' }}>
                    {props.t('docs_new_template')}
                </Button>
            )}
        </Box>
        {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
                <TailSpin height="40" width="40" color={Colors.sft_blue} ariaLabel="loading" />
            </Box>
        ) : (
            <Box sx={{ ...s.card, overflow: 'hidden', flex: '1 1 0', minHeight: 320 }}>
                    <DataGridPro
                          apiRef={apiRef}
                          initialState={initialGrid}
                          className={props.theme}
                          style={{ height: '100%', border: 'none' }}
                          columns={gridColumns}
                          rows={headers.filter((row)=>( (onlyApproved ? row.active == "0" : (includeApproved ? true : row.active != "0")) && ((row.type?.match(new RegExp(searchValue, "i")) || row.title?.match(new RegExp(searchValue, "i")) )))).map((row, index) => {return {
                                  id: row.id,
                                  lang: props.lang,
                                  title: row.title,
                                  type: row.type,
                                  created_at: row.created_at,
                                  updated_at: row.updated_at,
                                  created_by: row.created_by,
                                  updated_by: row.updated_by,
                                  edit: "Edit",
                                  delete: "Delete",
                                  copy: "Copy",
                                  confirmed: row.active != "0" ? 1 : 0
                              }                          
                          })} 
                          onColumnWidthChange={()=>{visibilityChangedHandler();}}
                          onColumnVisibilityModelChange={()=>{visibilityChangedHandler();}}
                          onPreferencePanelClose={()=>{visibilityChangedHandler();}}
                          rowThreshold={0}
                          rowHeight={38}
                          height={300}
                          loading={loading}
                          pagination={false}

                          /> 
            </Box>
        )}
        </>
    );
    if (props.embedded) return body;
    return (
        <div style={props.screen === "logging" ? {maxHeight: 750} : {}} className={(props.screen === "logging" ? ('log__margin_sidebar log__container_content _80perc ' + props.theme + ' container_content_' + props.theme + '  box_fade-in') : (props.screenWidth) < 600 ? 'not_expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme : 'expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme)} >
        <div className="container_list__title padding_top__10px">
            <h2 className={(props.theme==='dark') ? "dark container_list__title" : "light container_list__title"} type="text">Templates</h2>
        </div>
        {body}
    </div>
    );
}

export default TemplateScreen;
